import 'bootstrap/dist/css/bootstrap.css';
import React, {useState} from 'react';
import styled from 'styled-components'
import SidebarComponent from './Sidebar';
import OsdComponent from './Osd';

var ordinal = 0;

const AppWrapper = styled.div`
  display: grid;
  grid-template-columns: 20% 80%;
  height: 100vh;
`;

const htmlDecode = string => {
  const doc = new DOMParser().parseFromString(string, 'text/html');
  return doc.documentElement.textContent;
};

function App() {
  const [ocrText, setOcrText] = useState('Click on the little box in the top left corner of the zine viewer to select some text and see the translation.');
  //const [ordinal, setOrdinal] = useState(0);
  if (window.ordinal == null) {
    window.ordinal = 0;
  }
  const imageBase = 'https://images.cogapp.com/iiif/cogapp_hackday%2FFrench_Zines%2FZad_Kokar%2F';
  const images = [
    'annee_zero_avril_2016_tour%2F1_couv1-3-resp860.ptif/info.json',
    'annee_zero_avril_2016_tour%2Fpage1-37-resp860.ptif/info.json',
    'annee_zero_avril_2016_tour%2Fpage2-39-resp850.ptif/info.json',
    'annee_zero_avril_2016_tour%2Fpage3-35-resp860.ptif/info.json',
    'annee_zero_avril_2016_tour%2Fpage4-33-resp860.ptif/info.json',
    'annee_zero_avril_2016_tour%2Fpage5-29-resp860.ptif/info.json',
    'annee_zero_avril_2016_tour%2Fpage6-26-resp860.ptif/info.json',
    'annee_zero_avril_2016_tour%2Fpage7-24-resp860.ptif/info.json',
    'annee_zero_avril_2016_tour%2Fpage8-24-resp860.ptif/info.json',
  ];
  const apiBase = 'https://zines.cogapp.com/ocr/';
  var imageApi = images[window.ordinal].replace("%2F", "/");
  var imageApiMod = imageApi.replace("/info.json", "");
  const sendSelection = coords => {
    imageApi = images[window.ordinal].replace("%2F", "/");
    imageApiMod = imageApi.replace("/info.json", "");
    fetch(`${apiBase}${imageApiMod}/${coords.x},${coords.y},${coords.width},${coords.height}`)
      .then(res => {
        return res.text()
          .then(text => setOcrText(htmlDecode(text)));
      });
  };

  return (
    <AppWrapper>
      <SidebarComponent 
        ocrText={ocrText}
      />
      <OsdComponent
        images={images}
        apiBase={apiBase}
        //setOrdinal={setOrdinal}
        imageBase={imageBase}
        sendSelection={sendSelection}
      />
    </AppWrapper>
  );
}

export default App;
